import { render, staticRenderFns } from "./RecebimentoDetalhesApuracao.vue?vue&type=template&id=b3ca371c"
import script from "./RecebimentoDetalhesApuracao.vue?vue&type=script&lang=js"
export * from "./RecebimentoDetalhesApuracao.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDetalhesApuracao.vue?vue&type=style&index=0&id=b3ca371c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports